let list = [
  {
    path: "/",
    src: "/index",
    desc: "首页"
  },
  {
    path: "/demo",
    src: "/demo",
    desc: "demo"
  },
  // {
  //   path: "/introduction",
  //   src: "/introduction",
  //   desc: "简介"
  // },
  // {
  //   path: "/mainShow",
  //   src: "/mainShow",
  //   desc: "地图"
  // },
]

list = list.map( (item) => {
  item.component = resolve => require([`@/views${item.src}${item.src}`], resolve)
  item.name = item.desc
  return item
} )

export const routes = list